import { history } from "../../_helpers";
import { removeStoredValue, setStoredValue } from "../../_helpers/storagehelper";

const maintenanceMiddleware = (store) => (next) => (action) => {
  const isMaintenanceMode =
    store.getState()?.master?.applicationSettingsData?.IsApplicationMaintenance;
  // const isMaintenanceMode = 1;

  const isAsyncThunkPending =
    action.type?.endsWith("/pending") && action.meta?.arg !== undefined;

  if (isMaintenanceMode === 1 && isAsyncThunkPending) {
    removeStoredValue("menu_list");
    removeStoredValue("user");
    removeStoredValue("facilityDropDown");
    removeStoredValue("commonFacilityCode");
    setStoredValue("isLoggedIn", false);
    history.navigate("/Admin/Maintenance");

    // Navigate to maintenance page
    if (window.location.pathname !== "/Admin/Maintenance") {
      setTimeout(() => {
        history.navigate("/Admin/Maintenance");
      }, 0);
    }

    return;
  }

  return next(action);
};

export default maintenanceMiddleware;
